const $ = (id) => document.getElementById(id);

/** Short money everywhere (2.7): $4.62M, not $4,618,678. Under $10K it stays exact. */
function fmtShort(v) {
  const a = Math.abs(v);
  if (a >= 1e12) return `$${(a / 1e12).toFixed(2)}T`;
  if (a >= 1e9) return `$${(a / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `$${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e4) return `$${(a / 1e3).toFixed(0)}K`;
  return "$" + Math.round(a).toLocaleString("en-US");
}

function fmtMoney(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const sign = v < 0 && Math.round(Math.abs(v)) > 0 ? "-" : "";
  return sign + fmtShort(v);
}

function fmtPct(v) { return v === null || v === undefined ? "—" : v.toFixed(1) + "%"; }

function fmtNum(v) { return v === null || v === undefined ? "—" : v.toLocaleString("en-US", { maximumFractionDigits: 2 }); }

function cls(v) { return v > 0 ? "pos" : v < 0 ? "neg" : ""; }

function fmtArchetypeKpi(k) {
  // Product OS: shared formatter for the small archetype KPI chips on a
  // product card — $ values get a $ prefix, other units get a suffix,
  // and plain counts get neither.
  if (typeof k.value !== "number") return esc(String(k.value));
  if (k.unit === "$") return fmtMoney(k.value);
  const num = k.value.toLocaleString("en-US", { maximumFractionDigits: 2 });
  return k.unit ? `${num} ${esc(k.unit)}` : num;
}

function opt(list) { return list.map((v) => `<option value="${v}">${v}</option>`).join(""); }

function esc(s) { const d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

export { $, cls, esc, fmtArchetypeKpi, fmtMoney, fmtShort, fmtNum, fmtPct, opt };
